import { Component, OnInit, Input, Inject } from '@angular/core';
import { IPRUpdatesModel } from '../../../../Models/IPRUpdatesModel';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConfig } from '../../../../Services/app.config';
import { CheckAuth } from '../../../../Services/utility.service';
import { FormGroup, FormControl } from '@angular/forms';
import { MatrixFundDetailsService } from '../../../../../src/Services/matrix-fund-details.service';
import * as FileSaver from 'file-saver';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { iprupdatesService } from 'src/Services/frontiprupdatesService';
import { IPRupdatesPageModel, IPRupdatesPageModelV2 } from 'src/Models/IprupdatesPageModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ipr-carriers',
  templateUrl: './carriers.component.html',
  styleUrls: ['./carriers.component.css']
})
export class IPRCarriersComponent implements OnInit {
  userID: number = 0;  
  isAscending: boolean;
  statusCode: number = 0;
  appModel: any;

  upDowCarrierCSS: string = '';
  upDowPreviousNameCSS: string = '';  
  upDowUpdateDateCSS: string = '';
  
  isloading: boolean = false;
  iscarrierloading: boolean = false;
  tokenKey: string = '';
  iprupdatesModel: IPRUpdatesModel[] = [];
  iprupdatesExportModel: IPRUpdatesModel[] = [];
  iprCarrierDetailModel: IPRUpdatesModel[] = [];
  favouriteUpdateModel: IPRUpdatesModel[] = [];
  isRecords: boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  totalRecordsCount: number = -1;    
  queryParams: string = '';
  carrierForm: FormGroup;  
  totalunread: number = 0;
  alldata: string = 'all';
  unreaddata: string = 'unread';
  parameterModel = new IPRupdatesPageModel();
  parameterModelV2 = new IPRupdatesPageModelV2();
  baseUrl: string;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';

  listOfstateID: string[] = [];
  lastModifiedDetails: string;
  ClientSelectedTool: string;
  RegisteredChecked: boolean = true;
  NoLongerRegisteredChecked: boolean = true;
  NotRegisteredChecked: boolean = true;
  ActiveStates: string = '';
  DeActiveStates: string = '';
  NotRegisteredStates: string = '';
  SelectedCarrier: number = 0;
  CarrierName: string = '';
  FilterFavourite: number = 0;
  carrierFilter: string = ''
  productId : number;
  pageNumber:number=1;
  pageSize:number=10;
  rangeOfupdatesDates: any;
  iprUnread: number = 0;
  iprUnreadflag: boolean = true;

  constructor(private readonly MaxtixFund: MatrixFundDetailsService,
    @Inject('BASE_URL') baseUrl: string,
    private readonly htmlToPdf: HtmlToPdf, 
    private readonly iprupdatesService: iprupdatesService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {    
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    
    this.productId = ToolEnum.ipr;

    // Try to get token
    this.waitForTokenThenInit();
  }
  
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
    this.titleService.setTitle('Providers | JSi360');
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');

    this.movetotop();        
    this.parameterModelV2.keywordFilter = 'null';
    this.parameterModelV2.whereCondition = 'null';
    this.parameterModelV2.orderBy = 'UpdateDate DESC';
    this.upDowUpdateDateCSS = 'active';
    this.isAscending = true;
    this.parameterModelV2.fromupdatesDateFilter = "null";
    this.parameterModelV2.toupdatesDateFilter = "null";
    this.parameterModelV2.userID = this.userID.toString();
    this.parameterModelV2.updatetype = "1,0";
    this.parameterModelV2.pageNumber=this.pageNumber;
    this.parameterModelV2.pageSize=this.pageSize;
    this.isloading = false;
    this.GetCarriers();
    this.GetStateData();

    this.GetIPRNotification();
  }

  ngOnInit() {    
    
  }

  GetCarriers(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    let unreadonly = "0";
    if (this.queryParams == this.unreaddata) {
      unreadonly = "1";
    }
    this.parameterModelV2.unreadonly = unreadonly;
    this.iprupdatesService.GetCarriersV2(this.tokenKey, this.parameterModelV2.fromupdatesDateFilter.toString(), this.parameterModelV2.toupdatesDateFilter.toString(), this.parameterModelV2.updatetype, this.parameterModelV2.orderBy, this.parameterModelV2.keywordFilter, this.userID, this.FilterFavourite, this.carrierFilter,this.parameterModelV2.pageNumber,this.parameterModelV2.pageSize).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.iprupdatesModel = data["updates"];
          ApplicationActivityStore('View', 'IPR - Providers ', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Providers');

          if (this.iprupdatesModel.length > 0) {
            this.isRecords = true;
            this.totalRecordsCount = Number(this.iprupdatesModel[0].totalRecordCount);
            this.lastModifiedDetails = 'Last updated on ' + this.iprupdatesModel[0].lastModifiedDate;
          }
          else {
            this.totalRecordsCount = 0;
            this.isRecords = false;
          }
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error
      },
      () => this.isloading = false
    );
  }
  
  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.parameterModelV2.orderBy = sortBy + ' DESC';

      if (sortBy === "BusinessName") {
        this.upDowCarrierCSS = 'active';
        this.upDowPreviousNameCSS = '';
        this.upDowUpdateDateCSS = '';     
      }
      else if (sortBy === "PreviousName") {
        this.upDowCarrierCSS = '';
        this.upDowPreviousNameCSS = 'active';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowCarrierCSS = '';
        this.upDowPreviousNameCSS = '';
        this.upDowUpdateDateCSS = 'active';       
      }      
    }
    else {
      this.isAscending = false;
      this.parameterModelV2.orderBy = sortBy;

      if (sortBy === "BusinessName") {
        this.upDowCarrierCSS = 'active-up';
        this.upDowPreviousNameCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "PreviousName") {
        this.upDowCarrierCSS = '';
        this.upDowPreviousNameCSS = 'active-up';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowCarrierCSS = '';
        this.upDowPreviousNameCSS = '';
        this.upDowUpdateDateCSS = 'active-up';
      }
    }
    this.parameterModelV2.pageNumber=1;
    this.GetCarriers();
  }
 
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  keywordFilters($event) {
    this.parameterModelV2.pageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.parameterModelV2.keywordFilter = $event.target.value;
    else
      this.parameterModelV2.keywordFilter = 'null';

    this.GetCarriers();
  }

  isUpdatesDatesFilter(value: any) {
    this.parameterModelV2.pageNumber = 1;
    if (value != null) {
      if (value.length == 2) {
        this.parameterModelV2.pageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.parameterModelV2.fromupdatesDateFilter = a;
        this.parameterModelV2.toupdatesDateFilter = f;
        this.GetCarriers();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.parameterModelV2.pageNumber=1;
    this.rangeOfupdatesDates = [];
    this.parameterModelV2.fromupdatesDateFilter = "";
    this.parameterModelV2.toupdatesDateFilter = "";

    this.GetCarriers();
  }  

  updatesCarrierFilterClear() {
    this.parameterModelV2.pageNumber=1;
    this.carrierFilter = '';
    this.GetCarriers();
  }

  updatetypechange($event) {
    if ($event.target.id == 'chkRegistered') {
      this.RegisteredChecked = $event.target.checked;
    }
    if ($event.target.id == 'chkNoLongerRegistered') {
      this.NoLongerRegisteredChecked = $event.target.checked;
    }
    if ($event.target.id == 'chkNotRegistered') {
      this.NotRegisteredChecked = $event.target.checked;
    }
    if ($event.target.checked) {
      if (this.parameterModelV2.updatetype == "-1") { this.parameterModelV2.updatetype = "" }
      if (this.parameterModelV2.updatetype == '' || this.parameterModelV2.updatetype == 'null') {
        this.parameterModelV2.updatetype = $event.target.value;
      }
      else {
        this.parameterModelV2.updatetype += ',' + $event.target.value;
      }
    }
    else {
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace($event.target.value, "");
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace(/,\s*$/, "");
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace(",,", ",");
      if (this.parameterModelV2.updatetype.charAt(0) == ",") {
        this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.slice(1)
      }
      if (this.parameterModelV2.updatetype == "") { this.parameterModelV2.updatetype = "" }
    }

    this.parameterModelV2.pageNumber=1;
    this.GetCarriers();
  }

 
  pdfDocument() {
   
    let mainURL = this.baseUrl;
    let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
    url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
    url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '0',this.productId).
      subscribe(data => {
        if (data['status'] == 'Success') {          
          this.downloadFile('Providers', data['url']);
        }
      },
        error => {
          this.statusCode = error;
          this.unblockDocument();
        }
      );

  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        ApplicationActivityStore('Download', 'IPR Providers File download ' + filename, this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/providers/Details');

        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.MaxtixFund.GetMatrixFundState(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          // Set All Item
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "View registered providers by state(s)",
          enableSearchFilter: false,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  FilterSelecteventState($event) {   
    this.parameterModelV2.pageNumber=1;
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.listOfstateID.push($event.id);
    this.getString(this.listOfstateID);
    this.parameterModelV2.keywordFilter = this.stateFilter;
    this.GetCarriers();
  }

  FilterDeSelectseventState($event) {    
    this.parameterModelV2.pageNumber=1;
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.getString(this.listOfstateID);
    this.parameterModelV2.keywordFilter = this.stateFilter;
    this.GetCarriers();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e != element);
  }

  getString(array: any) {
    let sprator = '';
    this.stateFilter = '';
    for (let iCounter = 0; iCounter < array.length; iCounter++) {
      this.stateFilter += sprator + array[iCounter];
      sprator = ',';
    }
    if (this.stateFilter == '') {
      this.ClearAllStatus();
    }
  }

  onSelectAllStateList($event) {    
    this.parameterModelV2.pageNumber=1;
    this.stateFilter = '';
    if ($event != "" && $event != null) {
      for (let iCounter = 0; iCounter < $event.length; iCounter++) {
        this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event[iCounter].id);
        this.listOfstateID.push($event[iCounter].id);
      }
      this.getString(this.listOfstateID);
      this.parameterModelV2.keywordFilter = this.stateFilter;
    }
    this.GetCarriers();
  }

  onDeSelectAllStateList($event) {    
    this.parameterModelV2.pageNumber=1;
    this.listOfstateID = [];
    this.stateFilter = '';
    this.parameterModelV2.keywordFilter = '';
    this.ClearAllStatus();
    this.GetCarriers();
     
  }
  ClearAllStatus() {
    this.parameterModelV2.updatetype = "";
    this.RegisteredChecked = true;
    this.NoLongerRegisteredChecked = true;
    this.NotRegisteredChecked = true;
    this.parameterModelV2.updatetype = "1,0";
  }
  GetCarrierDetailsByID(carrierId: number): void {
    this.RemoveCarrier();
    this.CarrierName = '';
    this.iscarrierloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetIPRUpdatesFindByCarrierID(this.tokenKey, carrierId, this.productId).subscribe(
      data => {
        this.iprCarrierDetailModel = data["updates"];
        this.CarrierName = this.iprCarrierDetailModel[0].businessName;
        this.ActiveStates = this.iprCarrierDetailModel[0].listOfActiveStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        this.DeActiveStates = this.iprCarrierDetailModel[0].listOfDeActiveStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        this.NotRegisteredStates = this.iprCarrierDetailModel[0].listOfNotRegisteredStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        ApplicationActivityStore('View', 'IPR - Providers', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Providers/details', null);


        this.unblockDocument();
        this.iscarrierloading = false;
      },
      error => {
        this.statusCode = error;
        this.unblockDocument();
        this.iscarrierloading = false;
      }
    );
  }
  RemoveCarrier() {
    this.iprCarrierDetailModel = [];
    this.ActiveStates = '';
    this.DeActiveStates = '';
    this.NotRegisteredStates = '';
  }

  AddToFavourite(update, IsFavourite: number) {
    let CarrierId = update.carrierId;
    if (IsFavourite == 0) {
      this.SelectedCarrier = CarrierId;
      this.favouriteUpdateModel = update;
      var elem = document.getElementById("lnkFavouriteValidation");
      elem.click();
    }
    else {
      this.SaveFavourite(CarrierId, IsFavourite, update);
    }
  }

  SaveFavourite(CarrierId: number, IsFavourite: number, update) {    
    this.blockDocument();
    document.getElementById("btnClose").click();
    this.iprupdatesService.ClientCarrierFavouriteAdd(this.tokenKey, this.userID, CarrierId, IsFavourite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavourite == 1) {
            this.showMessage('Selected provider added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected provider removed successfully from favorite list.', 'Favorite', 'success');
          }
          update.favourite = IsFavourite === 1 ? 1 : 0;         
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  GetFavourite(IsFavourite: number) {
    this.parameterModelV2.pageNumber=1;
    if (IsFavourite == 1) {
      this.FilterFavourite = 1;
    }
    else {
      this.FilterFavourite = 0;
    }

    this.GetCarriers();
  }
  carrrierFilters($event) {
    this.parameterModelV2.pageNumber=1;
    if ($event.target.value != "" && $event.target.value != null)
      this.carrierFilter = $event.target.value;
    else
      this.carrierFilter = '';

    this.GetCarriers();
  }  

  pageChanged($event: any) {
    this.parameterModelV2.pageNumber = $event.page;
    this.GetCarriers();
  }

  GetIPRNotification(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.userID = +sessionStorage.getItem('UserId');
    this.iprupdatesService.GetIPRUpdatesUnread(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.iprUnread = data["updates"].length;
          sessionStorage.setItem('iprUnread', this.iprUnread.toString());

          if (this.iprUnread > 0) {
            sessionStorage.setItem('iprUnreadflag', 'false');
            this.iprUnreadflag=false;
          }
        }
      },
      error => {
        
      },
    );
  }
  

  ExportCarriers(): void {
     this.blockDocument();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    
    this.iprupdatesService.GetCarriersV2(this.tokenKey, this.parameterModelV2.fromupdatesDateFilter.toString(), this.parameterModelV2.toupdatesDateFilter.toString(), this.parameterModelV2.updatetype, this.parameterModelV2.orderBy, this.parameterModelV2.keywordFilter, this.userID, this.FilterFavourite, this.carrierFilter,1,1000000).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.iprupdatesExportModel = data["updates"];
          ApplicationActivityStore('Export', 'IPR - Providers ', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Providers');

          setTimeout(() => {
          this.pdfDocument();  
          }, 5000);
          
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error;
        this.unblockDocument();
      }
    );
  }
}
